var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "indigo darken-4"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.forgotPassword')))]), _c('v-spacer'), _c('v-avatar', {
    attrs: {
      "tile": _vm.tile,
      "size": "32",
      "color": "grey lighten-4"
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/mobile-info-192.png",
      "alt": "avatar"
    }
  })])], 1), _c('v-card-text', [_c('v-alert', {
    attrs: {
      "value": _vm.invalidCredentials,
      "color": "error"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$vuetify.t('$vuetify.app.invalidCredentials')) + "\n    ")]), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "username",
      "rules": [_vm.rules.required],
      "label": _vm.$vuetify.t('$vuetify.app.username')
    },
    model: {
      value: _vm.auth.username,
      callback: function callback($$v) {
        _vm.$set(_vm.auth, "username", $$v);
      },
      expression: "auth.username"
    }
  }), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "left": ""
    },
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("Back")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "large": "",
      "dark": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }